import React from "react";
import { Row, Col } from "react-bootstrap";

import { daysUntil, expiringInDays } from "utils/helper";

const CredentialItems = ({ credItems, onChangeHandler, selectedItems }) => {
  return (
    <React.Fragment>
      {credItems.length ? (
        <div className="dt-each mb-2">
          <div className="mb-2">
            <strong>Credentials</strong>
          </div>
          {credItems.map((item, i) => {
            let unverifiedlabel = "";
            let unverifiedBtnClass = "";
            let label = "";
            let btnClass = "";
            if (!item.verified) {
              unverifiedlabel = "Unverified";
              unverifiedBtnClass = "bg-info";
            }
            if (item.date_expires) {
              const expirationDate = new Date(item.date_expires);
              const daysRemaining = daysUntil(expirationDate);
              label = expiringInDays(daysRemaining);
              if (daysRemaining < 0) {
                btnClass = "bg-danger";
              } else {
                btnClass = "bg-light-red";
              }
            }

            return (
              <Row key={i}>
                <Col className="mb-2">
                  <input
                    type="checkbox"
                    id={`psv_item_cred_${item.provider.toString()}_${i}`}
                    checked={
                      selectedItems.some(
                        (selectedItem) =>
                          selectedItem.ProviderID === item.provider &&
                          selectedItem.Credentials &&
                          selectedItem.Credentials.includes(item._id)
                      ) ||
                      (item.submitted_to_verify
                        ? item.submitted_to_verify
                        : false)
                    }
                    onChange={(e) => onChangeHandler(e, "Credentials", item)}
                    disabled={
                      item.submitted_to_verify
                        ? item.submitted_to_verify
                        : false
                    }
                  />
                  <label
                    htmlFor={`psv_item_cred_${item.provider.toString()}_${i}`}
                  >
                    <span className="ml-1">
                      {item.credential.code} - {item.state}
                    </span>{" "}
                    {unverifiedlabel ? (
                      <span className={`badge ${unverifiedBtnClass}`}>
                        {unverifiedlabel}
                      </span>
                    ) : null}{" "}
                    {label ? (
                      <span className={`badge ${btnClass}`}>{label}</span>
                    ) : null}{" "}
                    {item.submitted_to_verify ? (
                      <span className="badge bg-secondary">In Process</span>
                    ) : null}
                  </label>
                </Col>
              </Row>
            );
          })}
        </div>
      ) : null}
    </React.Fragment>
  );
};

export default CredentialItems;
